import { z } from 'zod';

export const schemaChatResolvedPayload = z.object({});

export type Schema_ChatResolvedPayload = z.infer<typeof schemaChatResolvedPayload>;
